module.exports = __webpack_public_path__ + "static/media/gems.f51a82fc.jpg";